import React from 'react';
import { SparklesIcon, ArrowRightIcon } from 'lucide-react';
export function FindSolutionCTASection() {
  return <section id="find-solution" className="relative py-20 sm:py-24 px-4 sm:px-6 lg:px-8 overflow-hidden" style={{
    background: 'linear-gradient(180deg, #FAFAFA 0%, #F4EEFF 50%, #FAFAFA 100%)'
  }} data-id="element-149">
      {/* Decorative glow */}
      <div aria-hidden="true" className="absolute inset-0 pointer-events-none" style={{
      background: 'radial-gradient(ellipse 60% 50% at 50% 50%, rgba(124,77,255,0.10) 0%, transparent 60%)'
    }} data-id="element-150" />

      <div className="relative max-w-3xl mx-auto text-center" data-id="element-151">
        <span className="inline-flex items-center gap-1.5 text-[10px] sm:text-[11px] font-bold tracking-[0.18em] uppercase text-[#7C4DFF] bg-white border border-[#E9DDFF] px-2.5 py-1 rounded-full mb-5 shadow-sm" data-id="element-152">
          <SparklesIcon size={11} strokeWidth={2.2} data-id="element-153" />
          Подбор решения
        </span>

        <h2 className="text-[28px] sm:text-3xl lg:text-4xl font-bold text-gray-900 leading-[1.15] tracking-tight mb-4" data-id="element-154">
          Найдите своё решение
        </h2>
        <p className="text-base sm:text-lg text-gray-600 leading-relaxed mb-8 max-w-xl mx-auto" data-id="element-155">
          Расскажите о своей ситуации — покажем, как Meelo решает именно её.
          Пара кликов, и вы увидите готовый сценарий под ваш садик.
        </p>

        <a href="#/find-solution" className="group inline-flex items-center gap-2.5 bg-[#7C4DFF] text-white font-semibold text-base px-7 sm:px-8 py-3.5 sm:py-4 rounded-full shadow-[0_8px_24px_-8px_rgba(124,77,255,0.45)] hover:bg-[#651FFF] hover:shadow-[0_12px_32px_-8px_rgba(124,77,255,0.55)] hover:-translate-y-0.5 transition-all duration-200" data-id="element-156">
          Открыть подбор решения
          <ArrowRightIcon size={18} strokeWidth={2.2} className="transition-transform group-hover:translate-x-0.5" data-id="element-157" />
        </a>

        <p className="text-xs sm:text-sm text-gray-500 mt-5" data-id="element-158">
          Бесплатно · Без регистрации · 1 минута
        </p>
      </div>
    </section>;
}